import { Ptag } from "components/core/fonts";
import { FlexRow } from "pages/UniversalSetup/UniversalCorporateBuffer/bufferCard";
import React from "react";
import { useNavigate } from "react-router";
import { colors, theme } from "theme";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function PageHeader({ header, prev_page, subheader, styles }) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (

    <FlexRow
      style={{
        cursor: `${prev_page}? pointer: ''`,
        display: "flex",
        gap: "0.6rem",
        alignItems: "center",
        marginBottom: '24px',
        ...styles
      }}
    >
      {prev_page && (
        <IconButton
          onClick={goBack}
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
      )}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Ptag
          fontWeight="700"
          fontSize="24px"
          fontFamily="Montserrat"
          color={colors.primaryColor}
        >
          {header}
        </Ptag>
        {subheader && <Ptag fontFamily="Montserrat" opacity= "0.8" marginTop="8px" fontSize="12px" color="#888888">{subheader}</Ptag>}
      </div>
    </FlexRow>
  );
}

export default PageHeader;
